import { FC, Fragment, useReducer } from 'react';

import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';

import { initialValues, SlideForm } from '../form';
import { SlideFormDialog } from '../slideFormDialog/SlideFormDialog';

import { mainScreenSettingsService } from 'v2/api/mainScreenSettingsService';
import { handleHttpError } from 'v2/utils';

interface CreateSlideButtonProps {
  onSuccess: VoidFunction;
}

export const CreateSlideButton: FC<CreateSlideButtonProps> = ({ onSuccess }) => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const { trigger, isMutating } = useSWRMutation('createSlide', mainScreenSettingsService.createSlide, {
    onSuccess: () => {
      onSuccess();
      toast.success('The slide has been successfully created');
      setOpen();
    },
    onError: handleHttpError,
  });

  const handleSubmit = (values: SlideForm, resetForm: VoidFunction) => {
    trigger(values).then(() => {
      resetForm();
    });
  };

  return (
    <Fragment>
      <Button onClick={setOpen} startIcon={<Plus />} variant="contained" size="large">
        Create Slide
      </Button>

      <SlideFormDialog
        title="Create Slide"
        isOpen={isOpen}
        onClose={setOpen}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        isSubmitting={isMutating}
      />
    </Fragment>
  );
};
